import { useQuery } from "react-query";
import { getData } from "../newApis/apiMethods";
import * as ajaxEndpoints from "../api/ajax-endpoints";

const getIncomeInterestReport = async ({
  StartDate,
  EndDate,
  // Page,
  // PageSize,
  GLParentId,
}) => {
  let queryParams = `?StartDate=${StartDate}&EndDate=${EndDate}`;

  if (GLParentId) {
    queryParams = `${queryParams}&GLParentId=${GLParentId}`;
  }
  const data = await getData(
    `${ajaxEndpoints.INTEREST_INCOME_REPORT}${queryParams}`
  );
  return data;
};

export default function useIncomeInterestReport({
  StartDate,
  EndDate,
  GLParentId,
}) {
  return useQuery(
    [
      {
        StartDate,
        EndDate,
        GLParentId,
      },
      "getIncomeInterestReport",
    ],
    getIncomeInterestReport
  );
}
